import { putRequest } from "../httpMethods";

export const putLmsBoards = (payload, id) =>
    putRequest(`lms/boards/${id}`, payload);

export const putLmsGrades = (payload, id) =>
    putRequest(`lms/grades/${id}`, payload);

export const putLmsTag = (payload, id) =>
    putRequest(`tags/${id}`, payload);

export const putLmsSubject= (payload, id) =>
    putRequest(`subject/${id}`, payload);

export const putLmsChapters= (payload, id) =>
    putRequest(`chapters/${id}`, payload);
export const putLmsTopics= (payload, id) =>
    putRequest(`topics/${id}`, payload);

export const putLmsPublications = (payload, id) =>
    putRequest(`lms/publications/${id}`, payload);


export const putLmsLanguage= (payload,id) =>
    putRequest(`lms/languages/${id}`, payload);


export const postUpdateLms= (payload,id) =>
    putRequest(`lms/update-course-content/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });


export const putUpdateLmsSubtopic= (payload,id) =>
    putRequest(`lms/subtopics/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

export const putUpdateLmsSubtopicThreejs= (payload,id) =>
    putRequest(`lms/three-d/subtopic/${id}`, payload);

export const putDocName = (payload, id) =>
    putRequest(`v1/document/${id}`, payload);  


export const putUpdateThreejsSubtopic= (payload,subtopicId) =>
    putRequest(`lms/course/three-d/${subtopicId}`, payload);


export const putUpdateActivityLms= (payload,id) =>
    putRequest(`v1/lms/activity/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });